import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue";
import { UiLoader } from '@huntflow/ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'page-inner',
    props: {
        loading: { type: Boolean, default: false }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.$style.root)
            }, [
                (__props.loading)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(_ctx.$style.loaderWrapper)
                    }, [
                        _createVNode(_unref(UiLoader), { size: "l" })
                    ], 2))
                    : _renderSlot(_ctx.$slots, "default", { key: 1 })
            ], 2));
        };
    }
});
